// extracted by mini-css-extract-plugin
export var isPrintedCell = "_y7-1";
export var printerIcon = "_y7-0";